(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Marks a node as initialised so shopify:section:load can't double-bind. */
  function claim(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* ---------- mobile nav ---------- */
  function initNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav || !claim(toggle, 'navReady')) return;

    toggle.addEventListener('click', function () {
      var open = nav.hasAttribute('data-open');
      if (open) {
        nav.removeAttribute('data-open');
        nav.setAttribute('hidden', '');
      } else {
        nav.setAttribute('data-open', '');
        nav.removeAttribute('hidden');
      }
      toggle.setAttribute('aria-expanded', String(!open));
    });
  }

  /* ---------- product gallery ---------- */
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery || !claim(gallery, 'galleryReady')) return;

    var track = gallery.querySelector('[data-gallery-track]');
    var slides = gallery.querySelectorAll('.gallery__slide');
    var dots = gallery.querySelectorAll('[data-gallery-dot]');
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (!track || slides.length < 2) return;

    var index = 0;
    var timer = null;

    function render() {
      track.style.transform = 'translateX(' + (index * -100) + '%)';
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === index);
      }
    }

    function go(n) {
      index = (n + slides.length) % slides.length;
      render();
    }

    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function start() {
      if (reduceMotion) return;
      stop();
      timer = window.setInterval(function () { go(index + 1); }, 6000);
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
    if (next) next.addEventListener('click', function () { go(index + 1); start(); });

    for (var d = 0; d < dots.length; d++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          go(parseInt(btn.getAttribute('data-gallery-dot'), 10));
          start();
        });
      })(dots[d]);
    }

    gallery.addEventListener('mouseenter', stop);
    gallery.addEventListener('mouseleave', start);

    render();
    start();
  }

  /* ---------- testimonial slider ---------- */
  function initTestimonialSliders() {
    var sliders = document.querySelectorAll('[data-tslider]');

    for (var s = 0; s < sliders.length; s++) {
      (function (slider) {
        if (!claim(slider, 'tsliderReady')) return;

        var track = slider.querySelector('[data-tslider-track]');
        var cards = track ? track.querySelectorAll('.testimonial') : [];
        if (!track || cards.length < 2) return;

        var prev = slider.querySelector('[data-tslider-prev]');
        var next = slider.querySelector('[data-tslider-next]');
        var dots = slider.querySelectorAll('[data-tslider-dot]');

        var autoplay = slider.getAttribute('data-autoplay') === 'true';
        var speed = (parseInt(slider.getAttribute('data-autoplay-speed'), 10) || 6) * 1000;
        var timer = null;
        var frame = null;

        function step() {
          if (cards.length < 2) return cards[0].offsetWidth;
          return cards[1].offsetLeft - cards[0].offsetLeft;
        }

        function maxScroll() {
          return track.scrollWidth - track.clientWidth;
        }

        function currentIndex() {
          var st = step();
          return st > 0 ? Math.round(track.scrollLeft / st) : 0;
        }

        function scrollToIndex(i) {
          track.scrollTo({ left: i * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
        }

        function syncControls() {
          var i = currentIndex();
          for (var d = 0; d < dots.length; d++) {
            dots[d].classList.toggle('is-active', d === i);
          }
          if (prev) prev.disabled = track.scrollLeft <= 1;
          if (next) next.disabled = track.scrollLeft >= maxScroll() - 1;
        }

        function advance() {
          if (track.scrollLeft >= maxScroll() - 1) {
            track.scrollTo({ left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
          } else {
            scrollToIndex(currentIndex() + 1);
          }
        }

        function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
        function start() {
          if (!autoplay || reduceMotion) return;
          stop();
          timer = window.setInterval(advance, speed);
        }

        if (prev) prev.addEventListener('click', function () { scrollToIndex(currentIndex() - 1); start(); });
        if (next) next.addEventListener('click', function () { scrollToIndex(currentIndex() + 1); start(); });

        for (var d = 0; d < dots.length; d++) {
          (function (btn) {
            btn.addEventListener('click', function () {
              scrollToIndex(parseInt(btn.getAttribute('data-tslider-dot'), 10));
              start();
            });
          })(dots[d]);
        }

        track.addEventListener('scroll', function () {
          if (frame) window.cancelAnimationFrame(frame);
          frame = window.requestAnimationFrame(syncControls);
        });

        // Pause while the visitor is interacting
        slider.addEventListener('mouseenter', stop);
        slider.addEventListener('mouseleave', start);
        slider.addEventListener('focusin', stop);
        slider.addEventListener('focusout', start);
        track.addEventListener('touchstart', stop, { passive: true });

        window.addEventListener('resize', syncControls);

        syncControls();
        start();
      })(sliders[s]);
    }
  }

  /* ---------- variant picker ---------- */
  function initVariantPicker() {
    var radios = document.querySelectorAll('[data-variant-radio]');
    if (!radios.length) return;

    function sync() {
      for (var i = 0; i < radios.length; i++) {
        var label = radios[i].closest('[data-bundle-option]');
        if (label) label.classList.toggle('is-selected', radios[i].checked);
      }
    }

    for (var i = 0; i < radios.length; i++) {
      if (claim(radios[i], 'variantReady')) {
        radios[i].addEventListener('change', sync);
      }
    }
    sync();
  }

  /* ---------- helpers ---------- */
  function setCartCount(count) {
    var nodes = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = count;
  }

  function toast(message, isError) {
    var el = document.createElement('div');
    el.textContent = message;
    el.setAttribute('role', 'status');
    el.style.cssText = [
      'position:fixed', 'top:20px', 'right:20px', 'z-index:9999',
      'padding:0.85rem 1.25rem', 'border-radius:10px', 'color:#fff',
      'font-family:inherit', 'font-size:0.92rem', 'font-weight:600',
      'box-shadow:0 8px 24px rgba(0,0,0,0.18)',
      'background:' + (isError ? '#b3261e' : '#3f7a2a')
    ].join(';');
    document.body.appendChild(el);
    window.setTimeout(function () { el.remove(); }, 3200);
  }

  /* ---------- add to cart ---------- */
  function initAddToCart() {
    var form = document.getElementById('ProductForm');
    if (!form || !claim(form, 'cartReady')) return;

    var submitBtn = form.querySelector('button[name="add"]');

    function addToCart() {
      var data = new FormData(form);
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.dataset.originalLabel = submitBtn.textContent;
        submitBtn.textContent = 'Adding...';
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: data
      })
        .then(function (res) {
          return res.json().then(function (json) {
            if (!res.ok) throw new Error(json.description || json.message || 'Could not add to cart');
            return json;
          });
        })
        .then(function () {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { setCartCount(cart.item_count); });
        })
        .catch(function (err) {
          toast(err.message, true);
          throw err;
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            if (submitBtn.dataset.originalLabel) submitBtn.textContent = submitBtn.dataset.originalLabel;
          }
        });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      addToCart().then(function () { toast('Added to cart'); }).catch(function () {});
    });

    var stickyAdd = document.querySelector('[data-sticky-add]');
    if (stickyAdd && claim(stickyAdd, 'stickyReady')) {
      stickyAdd.addEventListener('click', function () {
        addToCart().then(function () { toast('Added to cart'); }).catch(function () {});
      });
    }

    var buyButtons = document.querySelectorAll('[data-buy-now]');
    for (var i = 0; i < buyButtons.length; i++) {
      if (!claim(buyButtons[i], 'buyReady')) continue;
      buyButtons[i].addEventListener('click', function () {
        addToCart().then(function () { window.location.href = '/checkout'; }).catch(function () {});
      });
    }
  }

  /* ---------- collection sort ---------- */
  function initSort() {
    var select = document.querySelector('[data-sort-select]');
    if (!select || !claim(select, 'sortReady')) return;

    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  function init() {
    initNav();
    initGallery();
    initTestimonialSliders();
    initVariantPicker();
    initAddToCart();
    initSort();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
